export default __webpack_public_path__ + "static/avocat-girl-89eb5afec797ee8785c1c5b0129caf36.png";